import { useTranslation } from 'react-i18next';
import { TranslationKeys } from 'translations';
import { DataVendor, ExtendedDropzoneFile } from 'v2/models';
import * as yup from 'yup';

export function useBulkFileUploadSchema() {
  const { t } = useTranslation();

  const bulkFileUploadSchema = yup.object({
    fileUploadIDs: yup.string().required(),
    type: yup.string().required('File type is required.'),
    bulkUploadFiles: yup
      .array()
      .min(
        1,
        `Files with a ${t(
          TranslationKeys.company_one
        )} associated are required.`
      )
      .of(
        yup.object({
          isSelected: yup.boolean().required(),
          file: yup.mixed<ExtendedDropzoneFile>().required(),
          dataVendor: yup
            .mixed<DataVendor>()
            .required(
              `All the files must be associated with a ${t(
                TranslationKeys.company_one
              )}.`
            ),
        })
      ),
  });

  return bulkFileUploadSchema;
}
